// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3R2f4","errorLogs":"styles_errorLogs__r17y5"};